export const lessons = {
    1:[
        {
            id: 1,
            name: 'Exam 1',
            description: '',
            link: '',
        }
    ]
}